module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Qacuta/Nagano_Qacuta_GFDL_RCP85_Mid.png";